import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

type UiState = {
  loadingModalOpen: boolean;
};

const initialState: UiState = {
  loadingModalOpen: false
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openLoadingModal: state => {
      state.loadingModalOpen = true;
    },
    closeLoadingModal: state => {
      state.loadingModalOpen = false;
    }
  }
});

export const useLoadingModalOpened = () => {
  const isOpen = useSelector<{ ui: UiState }, boolean>(state => state.ui.loadingModalOpen);
  return isOpen;
};

export const { openLoadingModal, closeLoadingModal } = uiSlice.actions;
export default uiSlice;
